import React from 'react';
import SnackBar from './shared/SnackBar';

export const ProfileCheckPaperUpdate = () => {
  const url = new URL(window.location.toString());
  const uploadStatus = url.searchParams.get('PaperPostSuccess');
  url.searchParams.delete('PaperPostSuccess');
  window.history.replaceState({}, '', url);
  return (
    uploadStatus && (
      <SnackBar
        type={'success'}
        message={'Your paper is now on your profile.'}
      ></SnackBar>
    )
  );
};
